import axios from "axios";
import { getLocale } from "@/lib/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// a07c — the server answers in the app's language (promo box, purchase refusals).
api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers["Accept-Language"] = getLocale();
  return config;
});
